import striptags from 'striptags';

import type { SafetyHelmetProps } from 'src/components/SafetyHelmet/SafetyHelmet';
import { useBrandName } from 'src/hooks/useBrandName';

import { generateMetaDescription, generateMetaTitle } from '../utils';

import { useJobDetailsHeadTitle } from './title';

interface JobDetailsHeadProps {
  jobTitle: string;
  location: string;
  abstract: string;
  normalisedRoleTitle: string;
  broaderLocationName: string;
  normalisedOrganisationName: string;
}

export const useJobDetailsHead = ({
  jobTitle,
  location,
  abstract,
  normalisedRoleTitle,
  broaderLocationName,
  normalisedOrganisationName,
}: JobDetailsHeadProps): SafetyHelmetProps => {
  const brand = useBrandName();
  const jobsInLocation = location ? ` Job in ${location}` : '';
  const title = useJobDetailsHeadTitle({
    brand,
    normalisedRoleTitle,
    broaderLocationName,
    normalisedOrganisationName,
  });

  return {
    title,
    meta: [
      ...generateMetaTitle(`${jobTitle}${jobsInLocation} - ${brand}`),
      ...generateMetaDescription(striptags(abstract)),
    ],
  };
};
